/* Physalis — mejoras de la sección de encargos (argollas / compromiso / cotizar).
   1) Los botones "Cotizar" llevan al formulario el diseño, el metal y la foto elegidos.
   2) En /pages/cotizar: recuadro "Estás cotizando" y campos pre-llenados. */
(function () {
  var COTIZAR = '/pages/cotizar';
  var limpiar = function (s) { return (s || '').replace(/\s+/g, ' ').trim(); };
  var esMetal = function (s) { return /\b(oro|platino|plata)\b/i.test(s) && !/^(argollas?|anillos?)\b/i.test(s); };
  var capital = function (s) { s = limpiar(s).toLowerCase(); return s.charAt(0).toUpperCase() + s.slice(1); };

  function tipoDePagina(path) {
    if (/argollas/.test(path)) return 'Argollas de matrimonio';
    if (/compromiso|anillos/.test(path)) return 'Anillos de compromiso';
    if (/novias/.test(path)) return 'Joyas para novias';
    return '';
  }

  /* Nombre del diseño, en este orden:
     1) argollas: el bloque de texto anterior dentro de la misma grilla;
     2) compromiso: el último título de la misma sección que esté antes del enlace;
     3) el último título de la sección anterior. */
  var TITULOS = 'p.h5, .h5, h2, h3, h4';
  function antesDe(a, b) { return !!(a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING); }
  function tituloAntes(el) {
    var n = el.previousElementSibling;
    while (n) {
      var t = n.querySelector && n.querySelector(TITULOS);
      if (t && limpiar(t.textContent)) return limpiar(t.textContent);
      n = n.previousElementSibling;
    }
    var sec = el.closest('.shopify-section');
    if (sec) {
      var hs = sec.querySelectorAll(TITULOS), ultimo = '';
      for (var i = 0; i < hs.length; i++) if (antesDe(hs[i], el) && limpiar(hs[i].textContent)) ultimo = limpiar(hs[i].textContent);
      if (ultimo) return ultimo;
      var prev = sec.previousElementSibling;
      for (var k = 0; prev && k < 4; k++, prev = prev.previousElementSibling) {
        var ph = prev.querySelectorAll(TITULOS);
        if (ph.length) return limpiar(ph[ph.length - 1].textContent);
      }
    }
    return '';
  }

  function enlazarBotones() {
    var tipo = tipoDePagina(location.pathname);
    var links = document.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      var url;
      try { url = new URL(a.getAttribute('href'), location.origin); } catch (e) { continue; }
      if (url.pathname !== COTIZAR || url.search) continue;
      // Solo las fotos-botón traen etiqueta (metal o nombre); los enlaces dentro de un texto no.
      var esFoto = a.classList.contains('media-grid__item') || !!a.querySelector('img');
      var etiqueta = esFoto ? limpiar(a.textContent.replace(/cotizar/ig, '')) : '';
      var titulo = tituloAntes(a);
      var p = new URLSearchParams();
      if (tipo) p.set('tipo', tipo);
      if (etiqueta && esMetal(etiqueta)) { if (titulo) p.set('diseno', titulo); p.set('metal', etiqueta); }
      else if (etiqueta) { p.set('diseno', etiqueta); }
      else if (titulo) { p.set('diseno', titulo); }
      var img = a.querySelector('img');
      if (img) {
        var src = (img.currentSrc || img.src || '').replace(/([?&])width=\d+/, '$1').replace(/[?&]$/, '');
        if (src) p.set('foto', src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=240');
      }
      p.set('desde', location.pathname);
      a.setAttribute('href', COTIZAR + '?' + p.toString());
    }
  }

  function elegir(select, valor) {
    if (!select || !valor) return false;
    var v = limpiar(valor).toLowerCase();
    for (var i = 0; i < select.options.length; i++) {
      var o = limpiar(select.options[i].value || select.options[i].text).toLowerCase();
      var clave = o.replace(/\s*18\s*k\b/, '');  // 'oro amarillo 18 k' -> 'oro amarillo'
      if (o === v || (o && v.indexOf(o) === 0) || (o && o.indexOf(v) === 0) || (clave && clave.length > 4 && v.indexOf(clave) === 0)) {
        select.selectedIndex = i;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
    }
    return false;
  }
  function marcar(el) { if (el) el.classList.add('physalis-prellenado'); }
  function campo(nombre) { return document.querySelector('[name="contact[' + nombre + ']"]'); }

  function prellenarCotizar() {
    var q = new URLSearchParams(location.search);
    var tipo = q.get('tipo'), diseno = q.get('diseno'), metal = q.get('metal'), foto = q.get('foto'), desde = q.get('desde');
    if (!tipo && !diseno) return;
    // El formulario de cotizar es el que tiene campo de mensaje (el de suscripción también envía a /contact)
    var cuerpo = document.querySelector('[name="contact[body]"]');
    var form = cuerpo && cuerpo.closest('form');
    if (!form) return;

    var t = campo('Qué quieres cotizar?'); if (elegir(t, tipo)) marcar(t);
    var d = campo('Diseño de referencia'); if (d && diseno) { d.value = capital(diseno).replace(/\s*\/\s*/g, ', '); marcar(d); }
    var m = campo('Metal'); if (elegir(m, metal)) marcar(m);

    // La foto viaja con el formulario como link (campo oculto), para que llegue en el correo.
    var fotoOk = foto && (foto.indexOf(location.origin + '/cdn/') === 0 || /^https:\/\/(cdn\.shopify\.com|physalisjoyas\.com)\//.test(foto));
    if (fotoOk) {
      var grande = foto.replace(/([?&])width=\d+/, '$1width=1200').replace(location.origin, 'https://physalisjoyas.com');
      var oculto = form.querySelector('[name="contact[Foto del diseño]"]') || document.createElement('input');
      oculto.type = 'hidden'; oculto.name = 'contact[Foto del diseño]'; oculto.value = grande;
      form.appendChild(oculto);
    }

    var caja = document.createElement('div');
    caja.className = 'physalis-eleccion';
    var html = '<div class="physalis-eleccion__fila">';
    if (fotoOk) html += '<img src="' + foto.replace(/"/g, '') + '" alt="" width="96" height="96">';
    html += '<div><small>Estás cotizando</small><strong></strong><span class="physalis-eleccion__tipo"></span><span class="physalis-eleccion__metal"></span></div></div>';
    if (desde && /^\/pages\/[a-z0-9-]+$/.test(desde)) html += '<a class="physalis-eleccion__volver" href="' + desde + '">← Elegir otro diseño</a>';
    caja.innerHTML = html;
    caja.querySelector('strong').textContent = capital(diseno || tipo).replace(/\s*\/\s*/g, ', ');
    if (diseno && tipo) caja.querySelector('.physalis-eleccion__tipo').textContent = tipo;
    if (metal) caja.querySelector('.physalis-eleccion__metal').textContent = 'Metal: ' + capital(metal);
    form.parentNode.insertBefore(caja, form);
  }

  var css = document.createElement('style');
  css.textContent =
    '.physalis-eleccion{border:1px solid rgb(var(--border-color, 221 221 221));background:rgb(245 245 242);padding:16px;margin:0 0 24px;text-align:left}' +
    '.physalis-eleccion__fila{display:flex;gap:14px;align-items:center}' +
    '.physalis-eleccion img{width:96px;height:96px;object-fit:cover;flex:none}' +
    '.physalis-eleccion small{display:block;font-size:11px;letter-spacing:.12em;text-transform:uppercase;opacity:.7}' +
    '.physalis-eleccion strong{display:block;font-family:var(--heading-font-family);font-size:17px;color:rgb(20 40 11);margin:2px 0}' +
    '.physalis-eleccion span{display:block;font-size:14px}' +
    '.physalis-eleccion__volver{display:inline-block;margin-top:10px;font-size:13px;text-decoration:underline}' +
    '.physalis-prellenado{background-color:#f1f6ec !important;border-color:#9db58c !important}';
  document.head.appendChild(css);

  function iniciar() {
    if (location.pathname === COTIZAR) prellenarCotizar(); else enlazarBotones();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();
